import {get, post, } from './axios'
/**
 * 登录
 * @param {*} params 1. 密码登录 {loginType:0, mobile, password}
 * 2. 手机验证码登录 {loginType:1, mobile, authCode}
 */
export function login (params) {
    return post('/oauth/login', params, {})
}

// 获取手机验证码
/*!**
 * @param {手机号} phone
 * @param {类型} type 1注册2修改密码3重置密码4手机登录
 *!*/
/*export function getAuthCode (phone, type) {
    return get('/rock/unauth/api/user/getAuthSmsCode.o', {}, {
        params: {
            phone,
            type
        }
    })
}*/

export function getAuthCode (phone, type) {
    return get('/oauth/getAuthSmsCode', {phone, type}, {})
}

// 注册
export function register (phone, password, nextStepToken) {
    // return post('/rock/unauth/api/user/register.o', {mobile, authCode, password, token})
    return post('/oauth/register', {phone, password, nextStepToken}, {})
}

// 下一步
/*!**
 *
 * @param {*} mobile
 * @param {1 注册的下一步 3 找回密码 16 修改手机号} type
 * @param {*} authCode
 *!*/
export function nextStep ({phone,type,authCode,sessionId,sig,afsToken,scene}) {
    return get('/oauth/nextStep', {phone,type,authCode,sessionId,sig,afsToken,scene})
}
// 修改密码
/*!**
 *
 * @param {2 重置密码, 1 修改密码} changeType
 * @param {手机号} mobile
 * @param {*} token
 * @param {新密码} newPassword
 * @param {旧的密码， 修改密码时可用} password
 *!*/
export function changePassword (changeType, phone, authCode, token, newPassword, password = '') {
    return post('/oauth/updatePassword', {changeType, phone, authCode, token, newPassword, password},{})
}

export function verityToken (token) {
    return post('/oauth/verifyToken', {}, {
        params: {
            token: token
        }
    })
}

export function getPublickey() {
    return get('/oauth/publickey')
}

